module.exports = __webpack_public_path__ + "static/media/ticket.4246aa5f.svg";